import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Benefits } from './components/Benefits';
import { TeamSection } from './components/TeamSection';
import { LegalSection } from './components/LegalSection';
import { ContactSection } from './components/ContactSection';
import { SocialSection } from './components/SocialSection';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
export function App() {
  return <div className="min-h-screen flex flex-col w-full bg-white" data-id="element-0">
      <Navbar data-id="element-1" />

      <main className="flex-grow w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <Stats data-id="element-4" />
        <Benefits data-id="element-5" />
        <TeamSection data-id="element-6" />
        <LegalSection data-id="element-7" />
        <SocialSection data-id="element-8" />
        <ContactSection data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
      <WhatsAppFloat data-id="element-11" />
    </div>;
}